/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useCallback } from 'react';
import './banner.scss';
import { useWeb3React } from '@web3-react/core'
import { Mint, PricePerNFT, CurrentlyMintedNfts, MintBNB, PricePerNFTBNB } from '../../../hooks/MintAndPrice';
// import matic from '../../../Assets/social/matic.png'
import { ToastContainer, toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import rightImage from '../../../assets-gbeaks/1.png'
const Banner = () => {
    const [show, setshow] = useState(false);

    const { account } = useWeb3React();
    const [price, setPrice] = useState();
    const [priceBNB, setPriceBNB] = useState();
    const { MintUsingToken } = Mint(price)
    const { MintUsingBNB } = MintBNB(priceBNB)
    const [minted, setMinted] = useState(false);
    const [inProcess, setInProcess] = useState(false);
    const [cMinted, setCurrentlyMinted] = useState(0)
    const connectWallet = () => {
        setshow(true);
    }

    const mintUsingJFT = async (e) => {
        if (account) {
            try {
                e.preventDefault();
                setInProcess(true)
                const tx = await MintUsingToken()
                if (tx) {
                    toast.success('Successfully Minted Using Token', {
                        position: "top-right",
                        autoClose: 2000,
                    });
                    setMinted(true)
                }
                setInProcess(false)
                window.$("#hhhhh").modal('hide');

            }
            catch (err) {
                console.log(err)
                toast.error(err.message, {
                    position: "top-right",
                    autoClose: 2000,
                });
                setInProcess(false)
            }
        }
        else {
            window.$("#hhh").modal('hide');
            toast.error('Please Connect to wallet', {
                position: "top-right",
                autoClose: 2000,
            });
        }
    }

    const mintUsingBNB = async (e) => {
        if (account) {
            try {
                e.preventDefault();
                setInProcess(true)
                const tx = await MintUsingBNB()
                if (tx) {
                    toast.success('Successfully Minted Using BNB', {
                        position: "top-right",
                        autoClose: 2000,
                    });
                    setMinted(true)
                }
                setInProcess(false)
                window.$("#hhhhh").modal('hide');

            }
            catch (err) {
                console.log(err)
                toast.error(err.message, {
                    position: "top-right",
                    autoClose: 2000,
                });
                setInProcess(false)
            }
        }
        else {
            window.$("#hhh").modal('hide');
            toast.error('Please Connect to wallet', {
                position: "top-right",
                autoClose: 2000,
            });
        }
    }

    const { Price } = PricePerNFT();
    const { PriceInBNB } = PricePerNFTBNB()
    const { currentlyMinted } = CurrentlyMintedNfts()

    const NftPrice = useCallback(async (e) => {
        try {
            const p = await Price();
            const m = await currentlyMinted()
            const pb = await PriceInBNB()
            setCurrentlyMinted(m);
            setPrice(p);
            setPriceBNB(pb);
        }
        catch (err) {
            return false;
        }
    }, [Price, currentlyMinted, PriceInBNB])

    const UserMinted = useCallback(async (e) => {
        try {
            const m = await currentlyMinted()
            setCurrentlyMinted(m)
        }
        catch (err) {
            return false;
        }
    }, [currentlyMinted])
    useEffect(() => {
        NftPrice();
        UserMinted()
    })
    //    console.log("price",price)  
    return (
        <>
            <div className="container">
            <div className="main-banner1">
                <ToastContainer />
                      {/* <div className="row"> */}
                        {/* <div className="col-lg-6 col-md-6 col-sm-8 offset-sm-2"> */}
                            <div className="all_main">
                                <h1 className="main_heading">Jupiter Metis: A Project Of Jupiter Finance with 10000 Cryptographically Generated NFT's each with unique and appealing features</h1>
                                <button className="btn-red" type="button" onClick={connectWallet} >
                                    MINT NFTS
                                </button>
                                <h1 className="minted">Currently Minted : {cMinted}/10000 </h1>
                            {/* </div> */}
                        </div>
                        {/* <div className="col-lg-6 col-md-6 col-sm-8 offset-sm-2"> */}
                            <div className="img_wrapper">
                                <img src={rightImage} alt="" className="img-fluid"  />
                                {/* <img src={rightImage} alt="" className="img-fluid"  width="100%" height="500px"/>    */}
                            </div>
                        {/* </div> */}
                        
                    </div>
                {/* </div> */}

                <Modal isOpen={show} className="register-modal connect-modal" size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <ModalHeader >
                        <button type="button" className="close" data-dismiss="modal" onClick={() => setshow(false)} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody className="modal-body">
                        <div className="container main-divs">
                            <h3 className="white text-center">MINT YOUR NFT</h3>
                            <div className="for-padding">
                                <ul className="list-inline text-center">
                                    <li className="list-inline-item">
                                        <p className="ptb20 white">MINT YOUR NFT FOR ONLY <strong>{(price) / 10 ** 18} JFT</strong></p>
                                        <h5 className="ptb20 white">OR</h5>
                                        <p className="ptb20 white">MINT YOUR NFT FOR ONLY <strong>{(priceBNB) / 10 ** 18} BNB</strong></p>
                                    </li>
                                    {/* <li className="list-inline-item">
                                        <img     style={{ borderRadius: 20 }} width="30px" height="30px" className="img-fluid" alt="" />
                                    </li> */}
                                </ul>

                                <div className="row">
                                    <div className="col-sm-12 text-center">
                                        <button className="btn-common" type="button" onClick={mintUsingJFT}>Mint with JFT</button>
                                        <button className="btn-common" type="button" onClick={mintUsingBNB}>Mint with BNB</button>

                                        <div className="ptb20">
                                            <a className="white" href="/">By connecting, I accept Jupiter Metis' Terms of Service</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {inProcess ?
                                <div>
                                    <h3 className="white text-center">MINTING YOUR NFT...</h3>
                                    <div className="for-padding">
                                        <ul className="list-inline text-center">

                                            <li className="list-inline-item">
                                                {/* <img src="\opencanvas-assets\pop-up\mint-your-nft\fmt.jpeg" style={{ borderRadius: 20 }} width="30px" height="30px" className="img-fluid" alt="" /> */}
                                            </li>
                                        </ul>
                                        <div className="row">
                                            <div className="col-sm-12 text-center">
                                                <div className="ptb20">
                                                    <h4 className="white">CONFIRM TRANSACTION FROM YOUR WALLET</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                            }
                            {minted ?
                                <div>
                                    <h3 className="white text-center">YAYYY!</h3>
                                    <div className="for-padding">
                                        <div className="row">
                                            <div className="col-sm-12 text-center">
                                                <div className="ptb20">
                                                    <h4 className="white">YOUR NFT HAS BEEN MINTED</h4>
                                                    {/* <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.</p> */}
                                                </div>
                                                {/* <button className="btn-common" type="button" onClick={viewNFT} >VIEW YOUR NFTS</button> */}
                                                {/* <Link className="btn-common"  to="/" >VIEW YOUR NFTS</Link> */}
                                            </div>
                                        </div>
                                    </div>
                                </div> : null
                            }
                        </div>
                    </ModalBody>
                </Modal>


            </div>
            {/* </div> */}
        </>
    )
}

export default Banner;

